var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 2.39999C8.21228 2.40004 8.41573 2.48435 8.56572 2.63439L10.9657 5.03439C11.1114 5.18528 11.1921 5.38736 11.1903 5.59712C11.1884 5.80687 11.1043 6.00752 10.956 6.15585C10.8077 6.30418 10.607 6.38831 10.3972 6.39013C10.1875 6.39196 9.9854 6.31132 9.83452 6.16559L8.00012 4.33119L6.16572 6.16559C6.01484 6.31132 5.81276 6.39196 5.603 6.39013C5.39324 6.38831 5.19259 6.30418 5.04427 6.15585C4.89594 6.00752 4.81181 5.80687 4.80998 5.59712C4.80816 5.38736 4.8888 5.18528 5.03452 5.03439L7.43452 2.63439C7.58452 2.48435 7.78797 2.40004 8.00012 2.39999ZM5.03452 9.83439C5.18454 9.68442 5.38799 9.60016 5.60012 9.60016C5.81225 9.60016 6.0157 9.68442 6.16572 9.83439L8.00012 11.6688L9.83452 9.83439C9.9854 9.68867 10.1875 9.60803 10.3972 9.60986C10.607 9.61168 10.8077 9.69581 10.956 9.84414C11.1043 9.99247 11.1884 10.1931 11.1903 10.4029C11.1921 10.6126 11.1114 10.8147 10.9657 10.9656L8.56572 13.3656C8.4157 13.5156 8.21225 13.5998 8.00012 13.5998C7.78799 13.5998 7.58454 13.5156 7.43452 13.3656L5.03452 10.9656C4.88455 10.8156 4.80029 10.6121 4.80029 10.4C4.80029 10.1879 4.88455 9.98442 5.03452 9.83439Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/Selector.b425ea4c7d1c3dc1a04ce3e5aafc1552.svg";
export { ForwardRef as ReactComponent };